import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { CostingCenterSelect } from "../CostingCenter/CostingCenterSelect";
import { _CostingCenterValue } from "../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idCostingCenterMethod: number;
}

export const CostingCenterValue = ({ idCostingCenterMethod }: Props) => {

    const value = useDataBean(_CostingCenterValue);

    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idCostingCenterMethod])

    const getLista = () => {

        value.instance.getCostingCenterValueCatalog(idCostingCenterMethod).then(
            // (resp: any) => {
            //     if (resp) {
            //         resp.forEach(element => {
            //             element.DataBeanProperties.Method = `${element.DataBeanProperties.BusinessCoreCode ? `${element.DataBeanProperties.BusinessCoreCode ?? "N/A"}-${element.DataBeanProperties.BusinessCoreName ?? "N/A"}` : "N/A"}`
            //         });
            //         setLista(resp)

            //     }
            // }

            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.Method = (user.DataBeanProperties.CostingCenterMethodCode ?? "") + "-" + (user.DataBeanProperties.CostingCenterMethodName ?? "");
                        user.DataBeanProperties.Costing = (user.DataBeanProperties.CostingCenterCode ?? "") + "-" + (user.DataBeanProperties.CostingCenterName ?? "")
                    });
                    setLista(x)
                }
                single.spinner(false)
            }
        )

    }


    const create = () => {
        value.setBean({
            IDCostingCenterMethod: idCostingCenterMethod
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        value.deleteItemVoid(value.bean.IDCostingCenterValue).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    // const editaItem = () => {
    //     console.log(SubMacroProcess.bean);
    //     SubMacroProcess.update().then(
    //         (resp: any) => {
    //             getLista();
    //             setModal({ ...modal, "view": false });
    //         }
    //     ).catch(err => {
    //         toast.error(err);
    //     })

    // }

    const editaItem = () => {

        value.instance.addCostingCenterValue(idCostingCenterMethod, value.bean.IDCostingCenter, value.bean.CostPercent).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                    getLista();
                    setModal({ ...modal, "view": false });
                }
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDCostingCenterValue', visible: true },
        { title: 'Centro de Costo', property: 'Costing', visible: true },
        { title: 'Modelo de Costeo', property: 'Method', visible: true },
        { title: 'Porcentaje de Costeo', property: 'CostPercent', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]

        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={value.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <CostingCenterSelect label="Centro de Costo" idSelector={value.bean.IDCostingCenter} onChange={(e) => { value.setBean({ ...value.bean, "IDCostingCenter": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Porcentaje</label>
                            <input type="text" name='CostPercent' className="form-control" value={value.bean.CostPercent} onChange={value.handleChange} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}